import httpClient from 'shared/lib/httpClient';
import { parseInsuranceTypeList } from '../schemas/MasterDataSchema';

export const getInsuranceTypeList = async (params) => {
  const response = await httpClient.get('/insurance-types', { params });
  return parseInsuranceTypeList(response?.data);
};
